<section class="end-cta">
  <article>
      <h2>Want to Learn More?</h2>
      <div class="button-box--single">
        <a [href]="learnMoreLink" 
          class="btn btn-secondary" 
          (click)="mailtoClick()">
          Contact Us Today
      </a>
      </div>
      
      <picture>
        <source type="image/webp" srcset="/assets/imgs/accents/coffee-cups.webp">
        <source type="image/png" srcset="/assets/imgs/accents/coffee-cups.png">
        <img type="image/png" src="/assets/imgs/accents/coffee-cups.png" width="364" alt="Two white mugs sit on a table, different coloured logos on each but they are, in fact, a team." title="Want to learn more?">
      </picture>
    </article>
</section>
